import { isFeatureLaunched } from '@commenda/feature-launches';
import { FeatureLaunch } from '@commenda/feature-launches/featureLaunchEnum';
import { IBusinessEntity } from '@commenda/types';
import { Locations } from '../../BusinessInformation/BusinessInformationTabs/Locations';
import { SummaryInfoWrapper } from './SummaryInfoWrapper';

type LocationInformationCardProps = {
  businessEntity: IBusinessEntity;
  onGoToForm: () => void;
};

export const LocationInformationCard = ({
  businessEntity,
  onGoToForm,
}: LocationInformationCardProps) => {
  return (
    <SummaryInfoWrapper title="Locations" onGoToForm={onGoToForm}>
        <Locations
          businessEntity={businessEntity}
          hideTitle
          hideEntityLocationsSection
          hideEditIconForFields={{
            registeredOfficeAddress: true,
            mailingAddress: true,
          }}
          hideCopyIconForFields={{
            registeredOfficeAddress: true,
            mailingAddress: true,
          }}
        />
    </SummaryInfoWrapper>
  );
};
